import LogApi from '@/api/common/log';
import {DEFAULT_POSTER_THUMB_TMG} from '@/constants/common/images';
import useGlobalUIStore from '@/stores';
import {getLocationForTagClickLog} from '@/utils';
import {convertViewCnt} from '@/utils/main';
import {sendClickLog} from '@/utils/main/my-plus/log';
import {Link, useNavigate} from 'react-router-dom';

/** 카테고리 아이템의 태그를 클릭했을 때 이동할 경로를 생성 */
export const getTagSearchPath = (tag, tab = 'live') => {
  return `/search?hash=hashtag&tagname=${encodeURIComponent(tag)}&hashtype=${tab}&stype=hash&acttype=total&location=directory`;
};

export const DirectoryCategoryListItem = ({index, item}) => {
  const navigate = useNavigate();
  const {isDarkMode} = useGlobalUIStore();

  const handleOnClickCategory = (e, categoryName) => {
    e.preventDefault();
    const encodeCategoryName = encodeURIComponent(categoryName);
    //클릭 로그
    sendClickLog('cate_list', {
      buttonType: 'directory_cate',
      location: 'directory',
      filterId: categoryName,
      filterIdx: index,
    });
    navigate(`/directory/category/${encodeCategoryName}/live`);
  };

  const handleImageError = (e) => {
    const imgElement = e.target;
    imgElement.src = DEFAULT_POSTER_THUMB_TMG(isDarkMode);
    imgElement.setAttribute('data-replaced', 'true');
  };

  /**
   * 드롭스 태그 클릭 시 로그를 발송하는 함수
   */
  const handleOnClickEventTag = () => {
    LogApi.sendClickLog({
      codeType: 'tags',
      sendData: {
        location: getLocationForTagClickLog(location.pathname, location.search),
        contentsType: 'live',
        buttonType: 'drops_tags',
      },
    });
  };

  return (
    <li key={item.categoryNo}>
      <a href='#' onClick={(e) => handleOnClickCategory(e, item.categoryName)}>
        {item.viewCnt > 0 && (
          <span className='views'>
            <em>{convertViewCnt(item.viewCnt)}</em>
          </span>
        )}
        <div className='thumb'>
          <img
            src={item.cateImg}
            alt={item.categoryName}
            onError={(e) => handleImageError(e)}
            loading='lazy'
          />
        </div>
        <div className='info_wrap'>
          <p className='title'>{item.categoryName}</p>
        </div>
      </a>
      <div className='tag_wrap'>
        {!!item.isDrops && (
          <Link
            className='drops'
            to={getTagSearchPath('드롭스')}
            onClick={handleOnClickEventTag}>
            <span>드롭스</span>
          </Link>
        )}
        {item.fixedTags &&
          item.fixedTags.length > 0 &&
          item.fixedTags.map(
            (data, idx) =>
              data.length > 0 && (
                <Link key={idx} to={getTagSearchPath(data)}>
                  {data}
                </Link>
              ),
          )}
      </div>
    </li>
  );
};
